import { createElement, FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { PhysicalFormValues } from '@components/EntityDrawers/drawers/Physical/form';
import Advanced from '@components/EntityDrawers/drawers/Physical/tabs/Advanced';
import Standard from '@components/EntityDrawers/drawers/Physical/tabs/Standard';
import { DrawerContentProps } from '@components/EntityDrawers/hocs/withDrawer';
import { TimeLineDateError } from '@constants/validation';
import useTwoDatesValidation from '@hooks/useTwoDatesValidation';

export const PhysicalContent: FC<DrawerContentProps> = ({ tab }) => {
  const form = useFormContext<PhysicalFormValues>();

  useTwoDatesValidation({
    form,
    startKeyName: 'timelineStartDate',
    endKeyName: 'timelineEndDate',
    error: () => TimeLineDateError,
  });

  return createElement([Standard, Advanced][tab ?? 0]);
};
